import { useMemo } from 'react'
import { Column } from 'react-table'
import { CSSObject } from '@ritualco/jutsu'
import { BasicTable } from 'components/BasicTable'
import { useContent } from 'lib/content/react'
import { Merchant } from 'types/entities'

const positionCellStyles: CSSObject = {
  color: 'grayscale.secondary',
  fontSize: 'xsmall',
  pl: 2,
  pr: 0,
  py: 3,
  textAlign: 'center',
}

export type RestaurantsTableProps = {
  merchants: Merchant[]
}

export const RestaurantsTable = ({ merchants }: RestaurantsTableProps) => {
  const { formatMessage } = useContent()
  const columns = useMemo<Column<Merchant>[]>(
    () => [
      {
        Header: formatMessage({
          id: 'pmportal.restaurantLists.positionOnList',
        }),
        columns: [
          {
            accessor: 'position',
          },
          {
            accessor: 'name',
          },
        ],
      },
      {
        Header: formatMessage({ id: 'pmportal.restaurantLists.address' }),
        columns: [
          {
            accessor: 'address',
          },
        ],
      },
      {
        Header: formatMessage({ id: 'pmportal.restaurantLists.inNetwork' }),
        columns: [
          {
            accessor: 'inMerchantNetwork',
            Cell: ({ value }) =>
              formatMessage({ id: `pmportal.global.${value ? 'yes' : 'no'}` }),
          },
        ],
      },
    ],
    [formatMessage]
  )

  return (
    <BasicTable
      columns={columns}
      data={merchants}
      placeholder={formatMessage({
        id: 'pmportal.restaurantLists.noRestaurantsAdded',
      })}
      tdProps={({ column }) =>
        column.id === 'position' ? { sx: positionCellStyles } : {}
      }
    />
  )
}
